// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import {  CanActivateFn, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { combineLatest, filter, map, of } from 'rxjs';
import { InitializeCoreData } from '../app-states/actions/app.actions';
import { identityState } from '../app-states/app.state';
import { AppEnvironmentService } from '../services/app-environment.service';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const appEnv = inject(AppEnvironmentService);
  const auth = inject(AuthService);

  let idToken =   localStorage.getItem('id_token')
  if (!idToken) {
    auth.clearStorage();
    router.navigate(['login'])
    return of(false);
  }

  store.dispatch(InitializeCoreData({ payload: {idToken: idToken} }));
  const identityState$ = store.pipe(select(identityState));

  return combineLatest(([identityState$])).pipe(filter(([identityState]) => identityState.status === 'checked'), map(([identityState]) => {
    if (identityState.identity !== null) {
      return true;
    } else {
      window.location.href = appEnv.appEnvData.reloadSessionExpired;
      return false;
    }
  }))

};
